import { api } from './config';
import type {
  CosmeticAnalysisRequest,
  CosmeticAnalysisResponse,
  CosmeticAnalysisHistoryPage,
} from '../types/cosmetic-analysis.types';

/**
 * 화장품 이미지 분석 API
 */
export const cosmeticAnalysisApi = {
  /**
   * 화장품 이미지 분석 (Public - 브랜드 사용자용)
   */
  analyze: async (imageUrl: string, additionalContext?: string): Promise<CosmeticAnalysisResponse> => {
    const response = await api.post<{ data: CosmeticAnalysisResponse }>('/cosmetic-analysis/analyze', {
      image_url: imageUrl,
      additional_context: additionalContext,
    } as CosmeticAnalysisRequest);
    return response.data.data;
  },

  /**
   * AI 서비스 상태 확인
   */
  getStatus: async (): Promise<{ configured: boolean }> => {
    const response = await api.get<{ data: { configured: boolean } }>('/cosmetic-analysis/status');
    return response.data.data;
  },

  /**
   * 화장품 이미지 분석 (Admin 전용)
   */
  analyzeAdmin: async (imageUrl: string, additionalContext?: string): Promise<CosmeticAnalysisResponse> => {
    const response = await api.post<{ data: CosmeticAnalysisResponse }>('/admin/cosmetic-analysis/analyze', {
      image_url: imageUrl,
      additional_context: additionalContext,
    } as CosmeticAnalysisRequest);
    return response.data.data;
  },

  /**
   * 분석 결과를 Excel로 다운로드 (분석 결과를 직접 전달)
   */
  exportResultToExcel: async (result: CosmeticAnalysisResponse, imageUrl: string): Promise<Blob> => {
    const response = await api.post('/admin/cosmetic-analysis/export-result', {
      result,
      imageUrl,
    }, {
      responseType: 'blob',
    });
    return response.data;
  },

  /**
   * 저장된 분석 이력 조회 (Admin 전용, 최신순 페이지네이션)
   */
  getHistory: async (page = 0, size = 20): Promise<CosmeticAnalysisHistoryPage> => {
    const response = await api.get<{ data: CosmeticAnalysisHistoryPage }>('/admin/cosmetic-analysis/history', {
      params: { page, size },
    });
    return response.data.data;
  },
};
